import { render, staticRenderFns } from "./ContestAreaInfo.vue?vue&type=template&id=0bd915e3&scoped=true&"
import script from "./ContestAreaInfo.js?vue&type=script&lang=js&"
export * from "./ContestAreaInfo.js?vue&type=script&lang=js&"
import style0 from "./ContestAreaInfo.scss?vue&type=style&index=0&id=0bd915e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd915e3",
  null
  
)

export default component.exports